import { createRouter, createWebHistory } from 'vue-router';
import Home from '../components/HomePage.vue';
import About from '../components/AboutPage.vue';
import TurboTatu from '../components/TurboTatu.vue';
import InventarioFacil from '../components/InventarioFacil.vue';
import DinoDash from '../components/DinoDash.vue';
import DoeFacil from '../components/DoeFacil.vue';
import AmazingPhotoEditor from '../components/AmazingPhotoEditor.vue';
import MeuQueridometro from '../components/MeuQueridometro.vue';
import PadroesSeguracaMeuQueridometro from '../components/PadroesSeguracaMeuQueridometro.vue';




const routes = [
  { path: '/', name: 'HomePage', component: Home },
  { path: '/AboutPage', name: 'Sobre', component: About },
  { path: '/turbotatu', name: 'TurboTatu', component: TurboTatu },
  { path: '/inventario-facil', name: 'InventarioFacil', component: InventarioFacil },
  { path: '/dino-dash', name: 'DinoDash', component: DinoDash },
  { path: '/doe-facil', name: 'DoeFacil', component: DoeFacil },
  { path: '/AmazingPhotoEditor', name: 'AmazingPhotoEditor', component: AmazingPhotoEditor },
  { path: '/MeuQueridometro', name: 'MeuQueridometro', component: MeuQueridometro },
  { path: '/PadroesSeguracaMeuQueridometro', name: 'PadroesSeguracaMeuQueridometro', component: PadroesSeguracaMeuQueridometro },

];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;